import { PricePointState } from "@/vuex/modules/inventory/pricePoint/pricePoint.types";

export const state: PricePointState = {
  products: []
};
